export enum ReportMode
{
    Edit,
    Preview,
    View
}